var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinResponse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D4E1D9;}\n\t.st1{fill:#F8EEE1;}\n\t.st2{fill:#BE694F;}\n\t.st3{fill:#EFC05D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.8,83.5L84.4,64.1c3.2-2.2,4-6.6,1.8-9.8c-2.1-3.1-6.3-3.9-9.4-2c-2,1.2-3.3,3.2-3.4,5.5 c-2.1-1-4.5-0.8-6.5,0.3c-3.4,2-4.5,6.3-2.5,9.7c1.9,3.1,5.8,4.3,9.1,2.8L84.8,90L95.8,83.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.5,155.1c5.5-3.3,21.5-19.2,10.1-38.6c-7.9-13.5-16.7-15.1-31.7-23.2c-6-3.9-12.5-14-14.2-16.8 c-2.8,1.6-4.1,9.8-4.1,9.8s-9.8-1.7-12.5-0.1c1.6,2.8,9.3,15.1,9.9,20c0.8,16.5-1.7,24.1,6.2,37.5C107.3,166,125,158.4,130.5,155.1 "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.7,133.5c-0.2-0.5-0.5-1-0.6-1.6c-2.3-8.1-4.5-16.2-6.8-24.2c-0.1-0.4-0.1-0.9,0-1.3 c0.3-0.9,1.2-1.3,2.1-1c0.2,0.1,0.4,0.2,0.6,0.3c2.4,1.3,4.8,2.6,7.3,3.9c0.2,0.1,0.4,0.2,0.6,0.3c0.5-0.8,1-1.5,1.5-2.2 c2.5-3.7,5.7-6.8,9.6-9.1c8.2-4.9,16.9-6,26.1-3.2c1.8,0.6,3.6,1.5,5.3,2.3c0.8,0.4,1.2,1.1,1,1.9c-0.2,0.8-0.8,1.3-1.8,1.3 c-3.7,0.1-7.2,0.8-10.6,2.2c-4.8,2-8.8,5.1-11.8,9.3c-1.3,1.9-2.4,3.9-3.7,5.9c0.3,0.2,0.5,0.3,0.6,0.4c2.5,1.4,5,2.7,7.5,4.1 c1,0.5,1.3,1.2,1.1,2.1c-0.2,0.7-0.7,1-1.3,1.2c-2.5,0.8-5,1.6-7.5,2.3c-5.6,1.8-11.2,3.5-16.8,5.3c-0.5,0.1-1,0.2-1.5,0.3 C111.3,133.8,111,133.7,110.7,133.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinResponse);
export default __webpack_public_path__ + "static/media/Protein_Response.b112cc90a0450986e720c864b47bebe9.svg";
export { ForwardRef as ReactComponent };